export const TEXT = {
  bold: "Sorry we don't take advanced bookings for 1-5 people,",
  normal: "but you can come down and have a walk-in and still throw axes!"
};
export const SUBTITLE = "Our Suggestions";
